import "./components/walk-in-camera-panel";
import "./components/walk-in-panel";
import "./components/walk-in-render-panel";
import "./components/walk-in-staging-panel";
import "./components/walk-in-views-panel";
import "./components/walk-in-walls-panel";
import WalkInCameraPanel from "./components/walk-in-camera-panel";
import WalkInPanel from "./components/walk-in-panel";
import WalkInRenderPanel from "./components/walk-in-render-panel";
import WalkInStagingPanel from "./components/walk-in-staging-panel";
import WalkInViewsPanel from "./components/walk-in-views-panel";
import WalkInWallsPanel from "./components/walk-in-walls-panel";
import elt from "../../html/elt";
import injectCSS from "../../html/inject-css";
import { DirectionalLightingViewConfig, SavedViewConfig, ShowWallConfig } from "../../views/views-config";
import { registerListener } from "../../html/register-listener";


export class WalkInComponent extends HTMLElement {

    viewsPanel: WalkInViewsPanel;
    wallsPanel: WalkInWallsPanel;
    stagingPanel: WalkInStagingPanel;
    cameraPanel: WalkInCameraPanel;
    renderPanel: WalkInRenderPanel;

    layout: HTMLElement;
    toolbar: HTMLElement;
    canvas: HTMLCanvasElement;

    constructor(directionalLighting: DirectionalLightingViewConfig, views: SavedViewConfig[], showWallDefaults: ShowWallConfig[]) {
        super();

        injectCSS(STYLESHEET);

        this.viewsPanel =   new WalkInViewsPanel(views);
        this.wallsPanel =   new WalkInWallsPanel(showWallDefaults);
        this.stagingPanel = new WalkInStagingPanel({directionalLighting});
        this.cameraPanel =  new WalkInCameraPanel();
        this.renderPanel =  new WalkInRenderPanel();

        const
            viewsBtn = elt('button', {class: 'btn btn-primary'},
                           elt('i', {class: 'bi bi-eye'}),
                           'Views'),
            wallsBtn = elt('button', {class: 'btn btn-primary'},
                           elt('i', {class: 'bi bi-columns'}),
                           'Walls'),
            stagingBtn = elt('button', {class: 'btn btn-primary'},
                            elt('i', {class: 'bi bi-house'}),
                             'Staging'),
            cameraBtn = elt('button', {class: 'btn btn-primary'},
                            elt('i', {class: 'bi bi-camera'}),
                            'Camera'),
            renderBtn = elt('button', {class: 'btn btn-primary'},
                            elt('i', {class: 'bi bi-image'}),
                            'Render');

        registerToggleListener(viewsBtn, this.viewsPanel);
        registerToggleListener(wallsBtn, this.wallsPanel);
        registerToggleListener(stagingBtn, this.stagingPanel);
        registerToggleListener(cameraBtn, this.cameraPanel);
        registerToggleListener(renderBtn, this.renderPanel);

        this.layout = elt('div', {class: 'walk-in-component-layout'});
        this.toolbar =
            elt('div', {class: 'walk-in-component-toolbar'},
                elt('div', {class: 'btn-group'},
                    viewsBtn,
                    wallsBtn,
                    stagingBtn,
                    cameraBtn,
                    renderBtn,
                   )
               );
        this.layout.append(this.toolbar);

        this.canvas = elt('canvas');
        this.layout.append(
            elt('div', {class: 'walk-in-component-canvas-container'}, this.canvas)
        );

    }

    connectedCallback() {
        this.append(this.layout);
        this.append(this.viewsPanel);
        this.append(this.wallsPanel);
        this.append(this.stagingPanel);
        this.append(this.cameraPanel);
        this.append(this.renderPanel);
    }

};
export default WalkInComponent;
window.customElements.define('walk-in-component', WalkInComponent);

const registerToggleListener = (btn: HTMLElement, panel: WalkInPanel) => {
    registerListener(btn, 'click', () => {
        panel.toggle(btn);
    });
}

const STYLESHEET = `
walk-in-component {
    position: absolute;
    left: 0; right: 0;
    top: 0; bottom: 0;

    & .walk-in-component-layout {
        position: absolute;
        left: 0; right: 0;
        top: 0; bottom: 0;

        display: grid;
        grid-template-rows: auto 1fr;
        grid-template-columns: 1fr;
    }

    & .walk-in-component-canvas-container {
        position: relative;

        & canvas {
            position: absolute;
            top: 0; left: 0; right: 0; bottom: 0;
            width: 100%;
            height: 100%;
        }
    }

    & .walk-in-component-toolbar {
        padding: 1rem;

        & i {
            padding-left: 0.5rem;
        }
    }

    & walk-in-views-panel, & walk-in-walls-panel, & walk-in-staging-panel, & walk-in-camera-panel, & walk-in-render-panel
    {
        background-color: var(--bs-gray-100);
        border: 1px solid var(--bs-gray-300);
        border-radius: var(--bs-border-radius);
        padding: 1rem;
    }

    & button i.bi {
        margin-right: 1rem;
    }
}
`;
